import { render, staticRenderFns } from "./CSwitchConfirm.vue?vue&type=template&id=7e09a970&"
import script from "./CSwitchConfirm.vue?vue&type=script&lang=js&"
export * from "./CSwitchConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports